<template>
	<div :view="view" :id="uid" :variant="variant">
		<ul :class="baseClass">
			<li
				v-for="(item, index) in items"
				:class="`${baseClass}__item`"
				:id="`${uid}_li`"
				:key="item.id"
				:title="item.title"
				:ref="hasMoreItems(item) ? 'posRef' : ''"
			>
				<BadgeCount
					:value="item.valueBadgeCount"
					v-if="item.valueBadgeCount"
					:class="'badge-count--absolute'"
				/>

				<ActionsSetAction
					:action="item.action"
					:page="item.page"
					:baseClass="`${baseClass}__`"
					:iconClass="item.iconClass"
					:id="`${uid}_${index}_asa`"
					:label="item.label"
					:type="item.type"
					:variant="variant"
					v-if="item.visible"
					@click="toggleMoreOptions"
					:loggingParams="item.loggingParams"
					:disabled="item.disabled"
				/>
			</li>
			<li
				:class="`${baseClass}__more-menu`"
				v-if="hasMoreActions"
				ref="listRef"
			>
				<ActionsSetMore
					:options="moreOptions"
					:id="`${uid}_asm`"
					:isOpen="isOpen"
					:variant="variant"
				/>
			</li>
		</ul>

		<PopperPosition
			trackedRefName="posRef"
			popoverRefName="listRef"
			placement="bottom-start"
			:popperVisible="isOpen"
			strategy="fixed"
			@positionUpdated="updateIconOrientation"
		/>
	</div>
</template>

<script>
import ActionsSetAction from '@/site-components/actions-set/actions-set-action';
import ActionsSetMore from '@/site-components/actions-set/actions-set-more-menu';
import DocumentClickedMixin from '@/mixins/document-click';
import BadgeCount from '@/components/visual/badge-count';
import PopperPosition from '@/components/visual/popper-position';

// mixins
import popperPositionMixin from '@/mixins/popper-position-mixin';

export default {
	name: 'ActionsSet',
	mixins: [
		DocumentClickedMixin('closeHandler', 'hasMoreActions'),
		popperPositionMixin
	],
	components: {
		ActionsSetAction,
		ActionsSetMore,
		BadgeCount,
		PopperPosition
	},
	model: {
		prop: 'options'
	},
	props: {
		options: {
			type: Array,
			default: () => []
		},
		view: {
			type: String,
			default: null
		},
		baseClass: {
			type: String,
			default: 'actions-set'
		}
	},
	data() {
		return {
			items: [],
			isOpen: false,
			moreOptions: []
		};
	},
	computed: {
		hasMoreActions() {
			return this.options && this.options.length > 0;
		}
	},

	methods: {
		hasMoreItems(item) {
			return item.items?.length > 0;
		},
		toggleMoreOptions() {
			this.isOpen = !this.isOpen;
		},
		closeHandler() {
			this.isOpen = false;
		}
	},
	watch: {
		options: {
			immediate: true,
			deep: true,
			handler(list) {
				//render only visible elements
				let visibles = arr => {
					if (arr && arr.length > 0) {
						return arr.filter(i => i.visible);
					}
					return [];
				};

				this.items = visibles(list);
				const moreOp = this.options.find(act => act.type == 'dropdown');
				if (moreOp && moreOp.items) {
					this.moreOptions = visibles(moreOp.items) || [];
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Actions Set - Reusable list of actions typically found on a card
    * Can use SCSS variables = TRUE
*/
.actions-set {
	text-align: right;
	list-style: none;
	padding-inline-start: 0;
	position: relative;
	display: flex;
	justify-content: flex-end;

	&__item {
		display: inline;
		text-align: center;
		margin-left: $gutter-sm;
	}

	&__itemDisabled {
		display: inline;
		text-align: center;
		margin-left: $gutter-sm;
		opacity: $disabled-opacity;
		&:active {
			pointer-events: none;
			opacity: $disabled-opacity;
		}
	}
}
</style>
